/* Stock guard for the app-style product grids.
   - Designs that are sold out: show a SOLD OUT badge, remove quick add, sink to the end of the grid.
   - Designs where the advertised option (full set / front pair) is sold out but another option is in stock:
     the + opens the product page instead of adding a sold-out item to the cart.
   - Replaces typed-in star ratings on the cards with the live Judge.me numbers (window.INC_RT). */
(function () {
  var CK = 'inc_stock_v1', TTL = 10 * 60 * 1000;
  function load() {
    try { var c = JSON.parse(sessionStorage.getItem(CK) || 'null'); if (c && Date.now() - c.t < TTL) return Promise.resolve(c.m); } catch (e) {}
    var all = [];
    function page(p) {
      return fetch('/products.json?limit=250&page=' + p, { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (j) {
        var ps = (j && j.products) || []; all = all.concat(ps);
        return ps.length === 250 && p < 6 ? page(p + 1) : null;
      });
    }
    return page(1).then(function () {
      var m = {};
      all.forEach(function (p) { m[p.handle] = p.variants.map(function (v) { return [v.title, !!v.available]; }); });
      try { sessionStorage.setItem(CK, JSON.stringify({ t: Date.now(), m: m })); } catch (e) {}
      return m;
    });
  }
  function want(card) {
    var pr = card.querySelector('.pr'); var t = pr ? pr.textContent.toLowerCase() : '';
    if (/full set/.test(t)) return /full|complete|mixed set/i;
    if (/driver|front/.test(t) && !/rear set in stock/.test(t)) return /driver|front/i;
    return null;
  }
  function sold(card) {
    var b = card.querySelector('.im') || card;
    if (!card.querySelector('.inc-so')) { var s = document.createElement('span'); s.className = 'badge inc-so'; s.textContent = 'Sold out'; b.appendChild(s); }
    card.classList.add('inc-sold');
    card.querySelectorAll('.badge:not(.inc-so)').forEach(function (x) { x.remove(); });
    var q = card.querySelector('.quick'); if (q) q.remove();
    card.dataset.o = '-1';
    var g = card.parentElement; if (g) g.appendChild(card);
  }
  function toPdp(card, note) {
    var q = card.querySelector('.quick'); if (!q) return;
    var a = card.querySelector('a[data-spa], h3 a'); if (!a) return;
    q.classList.add('inc-pdp'); q.setAttribute('aria-label', 'Choose options');
    /* keep the cart's free-shipping suggestions from offering this card's sold-out option */
    card.dataset.hh = card.dataset.h; card.removeAttribute('data-h');
    if (note && !card.querySelector('.inc-note')) { var n = document.createElement('small'); n.className = 'inc-note'; n.textContent = note; var pr = card.querySelector('.pr'); if (pr) pr.appendChild(n); }
  }
  /* capture phase: runs before the button's own onclick, so nothing sold out reaches the cart */
  document.addEventListener('click', function (e) {
    var q = e.target.closest && e.target.closest('.pc .quick.inc-pdp');
    if (!q) return;
    e.preventDefault(); e.stopImmediatePropagation();
    var a = q.closest('.pc').querySelector('a[data-spa], h3 a');
    if (a) { var h = a.getAttribute('data-spa'); if (h) location.hash = h; else location.href = a.href; }
  }, true);
  function ratings() {
    var R = window.INC_RT || {};
    document.querySelectorAll('.pc[data-h]').forEach(function (card) {
      var r = R[card.dataset.h]; if (!r || !r[1]) return;
      var html = '★ ' + Number(r[0]).toFixed(1) + ' <small>(' + r[1] + ')</small>';
      var rt = card.querySelector('.rt');
      if (!rt) { var h3 = card.querySelector('h3'); if (!h3) return; rt = document.createElement('span'); rt.className = 'rt'; h3.parentNode.insertBefore(rt, h3.nextSibling); }
      rt.innerHTML = html;
    });
  }
  function run() {
    ratings();
    load().then(function (m) {
      document.querySelectorAll('.pc[data-h]').forEach(function (card) {
        var v = m[card.dataset.h]; if (!v) return;
        var any = v.some(function (x) { return x[1]; });
        if (!any) return sold(card);
        var re = want(card);
        /* only when that option exists on the product and every one of them is sold out */
        if (re && v.some(function (x) { return re.test(x[0]); }) && !v.some(function (x) { return x[1] && re.test(x[0]); })) {
          var left = v.filter(function (x) { return x[1]; }).map(function (x) { return x[0]; });
          var rear = left.length && left.every(function (x) { return /rear/i.test(x); });
          toPdp(card, rear ? 'Rear set only in stock' : 'Limited options in stock');
        }
      });
    }).catch(function () {});
  }
  var st = document.createElement('style');
  st.textContent = '.pc.inc-sold .im img{opacity:.45;filter:grayscale(.6)}.pc .inc-so{background:#3a3a3d!important;color:#fff!important}.pc .inc-note{display:block;color:#f5b301}';
  document.head.appendChild(st);
  /* run after the app's own scripts have built the grid, and again whenever a grid view opens */
  function later() { setTimeout(run, 600); }
  if (document.readyState === 'complete') later(); else window.addEventListener('load', later);
  window.addEventListener('hashchange', later);
})();
